import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Discover.css'; 
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

// 分类数据
const categories = [
  { id: 'all', name: '全部' },
  { id: 'mystery', name: '推理悬疑' },
  { id: 'life', name: '生活百态' },
  { id: 'history', name: '历史文化' },
  { id: 'sci-fi', name: '科幻奇幻' },
  { id: 'horror', name: '恐怖惊悚' },
  { id: 'comedy', name: '搞笑幽默' },
  { id: 'romance', name: '爱情故事' },
  { id: 'popular', name: '热门精选' }
];

// 示例拼图数据（后期将从API获取）
const puzzlesData = [
  // 推理悬疑
  {
    id: 1,
    title: '消失的照片',
    creator: '谜语大师',
    date: '2024-01-05',
    category: 'mystery',
    difficulty: 'medium',
    views: 1250,
    comments: 89,
    favorites: 76,
    cover: 'https://source.unsplash.com/random/600x600?mystery'
  },
  {
    id: 2,
    title: '密室杀人案',
    creator: '福尔摩斯',
    date: '2024-01-12',
    category: 'mystery',
    difficulty: 'hard',
    views: 2348,
    comments: 156,
    favorites: 203,
    cover: 'https://source.unsplash.com/random/600x600?puzzle'
  },
  // 生活百态
  {
    id: 3,
    title: '奇怪的邻居',
    creator: '日常观察者',
    date: '2024-01-08',
    category: 'life',
    difficulty: 'easy',
    views: 952,
    comments: 47,
    favorites: 35,
    cover: 'https://source.unsplash.com/random/600x600?neighbor'
  },
  // 历史文化
  {
    id: 4,
    title: '古墓传说',
    creator: '历史学家',
    date: '2024-01-15',
    category: 'history',
    difficulty: 'medium',
    views: 1705,
    comments: 98,
    favorites: 124,
    cover: 'https://source.unsplash.com/random/600x600?history'
  },
  // 科幻奇幻
  {
    id: 5,
    title: '时间旅行者',
    creator: '未来人',
    date: '2024-01-10',
    category: 'sci-fi',
    difficulty: 'hard',
    views: 1832,
    comments: 134,
    favorites: 167,
    cover: 'https://source.unsplash.com/random/600x600?scifi'
  },
  // 恐怖惊悚
  {
    id: 6,
    title: '午夜来客',
    creator: '幽灵讲述者',
    date: '2024-01-18',
    category: 'horror',
    difficulty: 'medium',
    views: 1456,
    comments: 94,
    favorites: 96,
    cover: 'https://source.unsplash.com/random/600x600?horror'
  },
  // 更多拼图...
  {
    id: 7,
    title: '笑脸背后',
    creator: '心理大师',
    date: '2024-01-20',
    category: 'comedy',
    difficulty: 'medium',
    views: 1123,
    comments: 67,
    favorites: 84,
    cover: 'https://source.unsplash.com/random/600x600?comedy'
  },
  {
    id: 8,
    title: '遗失的信',
    creator: '浪漫主义者',
    date: '2024-01-22',
    category: 'romance',
    difficulty: 'easy',
    views: 1342,
    comments: 105,
    favorites: 142,
    cover: 'https://source.unsplash.com/random/600x600?romance'
  }
];

const Discover = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [filteredPuzzles, setFilteredPuzzles] = useState([]);
  const [loading, setLoading] = useState(true);

  // 添加body类名
  useEffect(() => {
    // 添加类名以便应用特定的CSS样式
    document.body.classList.add('discover-page');
    
    // 组件卸载时移除类名
    return () => {
      document.body.classList.remove('discover-page');
    };
  }, []);

  // 模拟数据加载
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      setFilteredPuzzles(puzzlesData); // 确保数据被正确设置
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // 根据分类筛选拼图
  useEffect(() => {
    if (activeCategory === 'all') {
      setFilteredPuzzles(puzzlesData);
    } else if (activeCategory === 'popular') {
      // 按照收藏量排序，取前10个
      const popular = [...puzzlesData].sort((a, b) => b.favorites - a.favorites).slice(0, 10);
      setFilteredPuzzles(popular);
    } else {
      const filtered = puzzlesData.filter(puzzle => puzzle.category === activeCategory);
      setFilteredPuzzles(filtered);
    }
  }, [activeCategory]);

  // 确保我们有数据可以显示
  const hasPuzzles = filteredPuzzles && filteredPuzzles.length > 0;

  return (
    <div className="elegant-app">
      <Header />
      <main className="elegant-main">
      <div className="discover-container">
        <div className="discover-content">
            <div className="elegant-create-header">
              <h1 className="elegant-create-title">发现海龟汤</h1>
              <p className="elegant-create-subtitle">探索更多精彩海龟汤，享受解谜乐趣</p>
            </div>
          
          {/* 分类筛选 */}
          <div className="discover-categories">
            {categories.map(category => (
              <button 
                key={category.id}
                className={`discover-category-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
          
          {/* 加载状态 */}
          {loading ? (
            <div className="discover-loading">
              <div className="loading-spinner"></div>
              <p>加载中，请稍候...</p>
            </div>
          ) : (
            <>
              {/* 拼图网格 */}
              {hasPuzzles ? (
                  <div className="puzzle-grid">
                  {filteredPuzzles.map(puzzle => (
                      <Link to={`/puzzle/${puzzle.id}`} className="puzzle-card" key={puzzle.id}>
                        <div className="puzzle-image">
                          <img 
                            src={puzzle.cover || '/images/default.png'} 
                            alt={puzzle.title} 
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = '/images/default.png';
                            }}
                          />
                      </div>
                      <div className="puzzle-info">
                          <h3>{puzzle.title}</h3>
                        <div className="puzzle-meta-author">
                          <span className="puzzle-creator">
                            {puzzle.creator || "匿名用户"}
                          </span>
                          <span className="puzzle-likes">
                            <i className="fas fa-heart"></i> {puzzle.favorites}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div style={{textAlign: 'center', margin: '50px 0'}}>
                  <p>暂无符合条件的拼图</p>
                </div>
              )}
              
              {/* 分页导航 - 静态示例 */}
              {hasPuzzles && (
                <div className="pagination">
                  <button className="pagination-button disabled">
                    <i className="bi bi-chevron-left"></i>
                    上一页
                  </button>
                  <span className="pagination-number active">1</span>
                  <span className="pagination-number">2</span>
                  <span className="pagination-number">3</span>
                  <span className="pagination-ellipsis">...</span>
                  <span className="pagination-number">10</span>
                  <button className="pagination-button">
                    下一页
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      </main>
      <Footer />
    </div>
  );
};

export default Discover; 